import React from 'react';

import { Card, Stack, Typography } from '@mui/material';

import {
  cardSx,
  topRowSx,
  iconBoxSx,
  columnSx,
  titleSx,
  subtitleSx,
} from './styles';

import { Building2 } from 'lucide-react';

interface BankAccountCardProps {
  title: string;
  iban: string;
  bank: string;
}

const BankAccountCard: React.FC<BankAccountCardProps> = ({
  title,
  iban,
  bank,
}) => {
  return (
    <Card sx={cardSx}>
      <Stack sx={topRowSx}>
        <Stack sx={iconBoxSx}>
          <Building2 size={28} color="#CCD4FF" />
        </Stack>

        <Stack sx={columnSx}>
          <Typography sx={titleSx}>{title}</Typography>
          <Typography sx={subtitleSx}>
            **** {iban} - {bank}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

export default BankAccountCard;
